import { deleteOrderIdCommentsCommentId } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { orderKeys } from "Order/Api/orderKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const orderMutationsResource = Resources.base.order.mutations;

export const useDeleteOrderCommentMutation = (orderId: number) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((commentId: number) =>
			deleteOrderIdCommentsCommentId(orderId, commentId),
		),
		onError: (error) => {
			console.error(
				`${t(orderMutationsResource.orderCommentDeleteError)}:`,
				error,
			);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: orderKeys.comments(orderId) });
			toast.success(t(orderMutationsResource.orderCommentDeleteSuccess));
		},
	});
};
